import React, { useLayoutEffect, useState, useEffect, useRef } from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";

import Modal from "react-modal";
import Swal from "sweetalert2";
import { TextBox, CheckBox, SelectBox } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import { groupService } from "../../../apis/apiServices/Group";
import { assetService } from "../../../apis/apiServices/Asset";

import { categoryService } from "../../../apis/apiServices/Category";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "@iconify/react";

export default function CategoryComponent() {
  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Category ";
    getCategoryList();
  }, []);

  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [isCityModalOpen, setIsCityModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [AssetGroupList, setAssetGroupList] = useState([]);
  const [AssetTypeList, setAssetTypeList] = useState([]);
  const [errors, setErrors] = useState({});
  const [AssetCategory, setAssetCategory] = useState([]);
  const refDataGrid = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeViewModal = () => {
    setIsModalOpen(false);
  };

  const [Category, setCategory] = useState({
    id: 0,
    code: "",
    name: "",
    ledgerCode: "",
    groupId: 0,
    groupName: "",
    isActive: true,
    assetTypeid: 0,
  });

  const getCategoryList = async () => {
    try {
      refDataGrid?.current?.instance?.beginCustomLoading();
      let response = await categoryService.getCategoryList();
      setAssetCategory(response?.data);
      const assetTypeResponse = await assetService.getassetType();
      setAssetTypeList(assetTypeResponse?.data);
      const groupResponse = await groupService.getGroupList();
      setAssetGroupList(groupResponse?.data);
    } catch (error) {
      console.log("Error getCityList===>", error);
    } finally {
      refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  useEffect(() => {
    getCategoryList();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    const newErrors = {};
    if (!Category.name) newErrors.name = "Please enter category name";
    if (Category.groupId === 0) newErrors.groupId = "Please select group.";
    if (Category.assetTypeid === 0)
      newErrors.assetTypeid = "Please select asset type.";
    if (!Category.ledgerCode) newErrors.ledgerCode = "Please enter ledger code";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsSubmitted(false);
      return;
    }

    try {
      let body = {
        id: Category.id,
        code: Category?.code || "",
        name: Category?.name || "",
        ledgerCode: Category?.ledgerCode || "",
        groupId: Category?.groupId || 0,
        isActive: Category?.isActive || false,
        assetTypeid: Category?.assetTypeid,
        ModifiedBy: user?.userId,
      };

      const response = await categoryService.addCategory(body);

      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        setIsSubmitted(false);
        setErrors(response?.errors || {});
        return;
      }

      getCategoryList();
      Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        navigate(("/Category", { replace: true }));
        closeModal();
      });
    } catch (error) {
      console.log(error);
    }
  };

  const openModal = () => {
    setIsCityModalOpen(true);
  };

  const closeModal = () => {
    setIsCityModalOpen(false);
    setIsSubmitted(false);
    setErrors({});
    setCategory({
      id: 0,
      code: "",
      name: "",
      ledgerCode: "",
      groupId: 0,
      groupName: "",
      isActive: true,
      assetTypeid: 0,
    });
  };

  const handleInputChange = (e, field) => {
    let err = { ...errors };
    if (field === "code") {
      err.code = "";
    }
    if (field === "name") {
      err.name = "";
    }
    if (field === "groupId") {
      err.groupId = "";
    }
    if (field === "assetTypeid") {
      err.assetTypeid = "";
    }
    if (field === "ledgerCode") {
      err.ledgerCode = "";
    }
    setErrors(err);
    setCategory((prev) => ({
      ...prev,
      [field]: e.value,
    }));
  };

  const renderStatusCell = ({ value }) => {
    const isActive = value === true;

    return (
      <div
      // style={{
      //     display: 'inline-flex',
      //     alignItems: 'center',
      //     padding: '0px 11px',
      //     borderRadius: '9999px',
      //     fontWeight: 500,
      //     color: isActive ? '#15803d' : '#dc2626',
      //     backgroundColor: isActive ? '#dcfce7' : '#fee2e2',
      //     fontSize: '14px',
      //     width: 'fit-content'
      // }}
      >
        <span />
        {isActive ? "Active" : "Inactive"}
      </div>
    );
  };
  const handleRowClick = (e) => {
    setCategory({
      id: e.data.id,
      code: e.data.code,
      name: e.data.name,
      ledgerCode: e.data.ledgerCode,
      isActive: e.data.isActive,
      groupId: e.data.groupId,
      assetTypeid: e.data.assetTypeId,
    });
  };
  const handledelete = (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Deleted", "", "success");
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              dataSource={AssetCategory}
              showColumnLines={false}
              ref={refDataGrid}
              showRowLines={true}
              showBorders={true}
              onRowClick={(e) => handleRowClick(e)}
              allowColumnResizing={false}
              allowColumnReordering={true}
              columnAutoWidth={true}
              width={"100%"}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  {
                    location: "before",
                    widget: "dxButton",
                    options: {
                      icon: "plus",
                      text: "Add",
                      hint: "Add",
                      type: "default",
                      stylingMode: "contained",
                      onClick: () => openModal(),
                    },
                  },
                  {
                    location: "before",
                    widget: "dxButton",
                    options: {
                      icon: "refresh",
                      text: "Refresh",
                      hint: "Refresh",
                      type: "default",
                      stylingMode: "outlined",
                      onClick: () => getCategoryList(),
                    },
                  }
                );
              }}
            >
              <HeaderFilter visible={false} />
              <Column
                width={60}
                caption={""}
                cellRender={(cellData) => {
                  return (
                    <span>
                      {/* <Icon
                            className="iconify-size mr-2"
                            title="View"
                            tooltip="View"
                            icon="solar:document-text-outline"
                            style={{ cursor: "pointer" }}
                            onClick={() => setIsModalOpen(true)}
                          /> */}

                      <Icon
                        className="iconify-size mr-2"
                        title="Edit"
                        tooltip="Edit"
                        icon="solar:pen-line-duotone"
                        style={{ cursor: "pointer" }}
                        onClick={() => setIsCityModalOpen(true)}
                      />

                      <Icon
                        className="iconify-size"
                        title="Delete"
                        tooltip="Delete"
                        icon="fluent:delete-32-regular"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => handledelete(e)}
                      />
                    </span>
                  );
                }}
              ></Column>

              <Column
                dataField="name"
                caption="Name"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column dataField="code" caption="Code" allowFiltering={false} />
              <Column
                dataField="groupname"
                visible={true}
                caption="Group Name"
                allowFiltering={false}
                allowSearch={true}
                alignment={"left"}
              />
              <Column
                dataField="assetType"
                visible={true}
                caption="Asset Type "
                allowFiltering={false}
                allowSearch={true}
                alignment={"left"}
              />
              <Column
                dataField="ledgerCode"
                caption="Ledger Code"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column
                dataField="isActive"
                caption="Status"
                cellRender={renderStatusCell}
                alignment="left"
                allowSearch={true}
              />
              <Column
                dataField="groupName"
                visible={false}
                caption="Group"
                allowFiltering={false}
                allowSearch={true}
              />

              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />

              <Export enabled={false} fileName="Vendors" />
            </DataGrid>
          </div>
        </div>
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={isCityModalOpen}
        className="react-modal resmodel"
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Category  Type Modal"
      >
        <form
          onSubmit={handleSubmit}
          style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
        >
          <div className="modal-header">
            <div className="modal-title">
              {Category.id === 0
                ? `Add Category`
                : `Update Category [${Category.name}]`}
            </div>
          </div>

          <div className="modal-body">
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="form-group">
                  <label>Code </label>
                  <TextBox
                    className="form-control form-control-sm"
                    height={37}
                    placeholder="Enter Code"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={Category.code}
                    onValueChanged={(e) => handleInputChange(e, "code")}
                  />
                  {errors.code && (
                    <div className="text-danger">{errors.code}</div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-12">
                <div className="form-group">
                  <label>
                    Group Name <span className="text-danger">*</span>{" "}
                  </label>
                  <SelectBox
                    className="basic-multi-select"
                    dataSource={AssetGroupList}
                    showClearButton={true}
                    displayExpr="name" // adjust according to your object
                    valueExpr="id"
                    placeholder="Select state"
                    value={Category.groupId}
                    onValueChanged={(e) => handleInputChange(e, "groupId")}
                  />
                  {errors.groupId && (
                    <div className="text-danger">{errors.groupId}</div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-12">
                <div className="form-group">
                  <label>
                    Name <span className="text-danger">*</span>
                  </label>
                  <TextBox
                    className="form-control form-control-sm"
                    height={37}
                    placeholder="Enter category name"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={Category.name}
                    onValueChanged={(e) => handleInputChange(e, "name")}
                  />
                  {errors.name && (
                    <div className="text-danger">{errors.name}</div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-12">
                <div className="form-group">
                  <label>
                    Asset Type <span className="text-danger">*</span>{" "}
                  </label>
                  <SelectBox
                    className="basic-multi-select"
                    dataSource={AssetTypeList}
                    displayExpr="name" // adjust according to your object
                    valueExpr="id"
                    showClearButton={true}
                    placeholder="Select Asset Type"
                    value={Category.assetTypeid}
                    onValueChanged={(e) => handleInputChange(e, "assetTypeid")}
                    // className={`form-control ${errors.stateId ? 'is-invalid' : ''}`}
                  />
                  {errors.assetTypeid && (
                    <div className="text-danger">{errors.assetTypeid}</div>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-12">
                <div className="form-group">
                  <label>
                    Ledger Code <span className="text-danger">*</span>
                  </label>
                  <TextBox
                    className="form-control form-control-sm"
                    height={37}
                    placeholder="Enter ledger code"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={Category.ledgerCode}
                    onValueChanged={(e) => handleInputChange(e, "ledgerCode")}
                  />
                  {errors.ledgerCode && (
                    <div className="text-danger">{errors.ledgerCode}</div>
                  )}
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div>
                  <CheckBox
                    text="Is Active"
                    value={Category.isActive}
                    onValueChanged={(e) => handleInputChange(e, "isActive")}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={closeModal}
              title="Cancel"
            >
              <i className="fas fa-times"></i> Cancel
            </button>
            <button type="submit" className="btn btn-primary btn-sm">
              {isSubmitted ? (
                <span title="In process">
                  <i className="fas fa-spinner fa-spin"></i> In process
                </span>
              ) : (
                <span title="Submit">
                  <i className="fas fa-check"></i> Submit
                </span>
              )}
            </button>
          </div>
        </form>
      </Modal>

      <Modal
        ariaHideApp={false}
        isOpen={isModalOpen}
        className="react-modal resmodel"
        onRequestClose={closeViewModal}
      >
        <form
          onSubmit={handleSubmit}
          style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
        >
          <div className="modal-header">
            <div className="modal-title">View Asset Sub Group</div>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <p>
                    <span className="labelview">Code: </span> {Category.code}
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <p>
                    <span className="labelview">Name: </span> {Category.name}
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <p>
                    <span className="labelview">Asset Group: </span>{" "}
                    {
                      AssetGroupList.find(
                        (item) => item.id === Category.groupId
                      )?.name
                    }
                  </p>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-group">
                  <p>
                    <span className="labelview">Status: </span>{" "}
                    {Category.isActive ? "Active" : "Inactive"}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={closeViewModal}
              title="Cancel"
            >
              <i className="fas fa-times"></i> Close{" "}
            </button>
          </div>
        </form>
      </Modal>
    </>
  );
}
